import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { axiosInstance } from "lib/axios";
import { analyticsAPI } from "services/apis.service";

export function usePublisherCommon() {
  const { publisherName } = useSelector((state) => state.publisher);
  const [publisherList, setPublisherList] = useState([]);
  const [queryString, setQueryString] = useState(publisherName || "");

  useEffect(() => {
    if (publisherName && publisherName !== queryString) {
      setQueryString(publisherName);
    }
  }, [publisherName, queryString]);

  const getPublisherList = async (searchQuery) => {
    if(searchQuery.length < 2) return;
    try {
      const response = await axiosInstance.get(analyticsAPI.getPublisherList + "?Search=" + searchQuery);
      setPublisherList(response.data);
    } catch (error) {
      console.error(error);
      setPublisherList([]);
    }
  };

  return {
    publisherList,
    queryString,
    setQueryString,
    getPublisherList,
  };
}